import { render, staticRenderFns } from "./Categories.vue?vue&type=template&id=5e497776&scoped=true&"
import script from "./Categories.vue?vue&type=script&setup=true&lang=js&"
export * from "./Categories.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e497776",
  null
  
)

export default component.exports